<template>
  <VDialog v-model="isShowModal" max-width="700">
    <VToolbar color="primary" density="compact">
      <VToolbarTitle> Request a check </VToolbarTitle>
      <VSpacer />
      <VBtn icon="mdi-close" variant="text" @click="handleClose()" />
    </VToolbar>
    <VCard>
      <VCardItem>
        <VCardText>
          <VForm v-model="formValid" @submit.prevent>
            <VRow>
              <VCol cols="12">
                <VTextField
                  label="How much have you paid HMRC?"
                  prepend-inner-icon="mdi-currency-gbp"
                  color="primary"
                  name="applicationNumber"
                  :rules="formRules.amountPaid"
                  v-model="form.amountPaid"
                  placeholder=""
                  :disabled="isLoading"
                  type="number"
                  variant="outlined"
                  :min="0"
                  :step="0.01"
                />
              </VCol>
              <VCol cols="12">
                <VTextField
                  type="date"
                  label="When did you pay HMRC?"
                  v-model="form.whenPaid"
                  :rules="formRules.whenPaid"
                  variant="outlined"
                  persistent-placeholder
                  prepend-inner-icon="mdi-calendar-clock"
                  prepend-icon=""
                  :disabled="isLoading"
                  input-format="dd/mm/yyyy"
                ></VTextField>
              </VCol>
              <VCol cols="12">
                <VLabel>Tick the years you have paid voluntary NI Contributions for:</VLabel>
                <VRow>
                  <VCol cols="6">
                    <VCheckbox
                      v-for="item in leftColumnYears"
                      :key="item.label"
                      v-model="item.isChecked"
                      :label="item.label"
                      :disabled="isLoading"
                      hide-details
                      density="compact"
                    />
                  </VCol>
                  <!-- Правая колонка -->
                  <VCol cols="6">
                    <VCheckbox
                      v-for="item in rightColumnYears"
                      :key="item.label"
                      v-model="item.isChecked"
                      :label="item.label"
                      :disabled="isLoading"
                      hide-details
                      density="compact"
                    />
                  </VCol>
                </VRow>
              </VCol>
              <VCol cols="12">
                <VBtn :loading="isLoading" type="submit" color="primary" block flat @click="handleSaveRequest()"
                  >Request a Check</VBtn
                >
              </VCol>
            </VRow>
          </VForm>
        </VCardText>
      </VCardItem>
    </VCard>
  </VDialog>
</template>

<script>
import { mapActions } from 'vuex';
// Service
import applicationService from '@/services/application-service/application.service';
//Text
import { successRequestCheckText, errorRequestCheckText } from '@/text/snackbarsText';
export default {
  emits: ['update:modelValue'],
  props: {
    modelValue: Boolean,
    modalRequestCheckYears: Array
  },
  watch: {
    modelValue(newVal) {
      if (newVal) {
        this.resetForm();
        this.initYearsSelected();
      }
    }
  },
  mounted() {
    this.initYearsSelected();
  },
  computed: {
    isShowModal() {
      return this.modelValue;
    },
    leftColumnYears() {
      const middleIndex = Math.ceil(this.form.yearsSelected.length / 2);
      return this.form.yearsSelected.slice(0, middleIndex);
    },

    rightColumnYears() {
      const middleIndex = Math.ceil(this.form.yearsSelected.length / 2);
      return this.form.yearsSelected.slice(middleIndex);
    }
  },
  data() {
    return {
      visiblePassword: false,
      formRules: {
        amountPaid: [(v) => !!v || 'Ammount required'],
        whenPaid: [
          (v) => !!v || 'Paid Date required',
          (v) => {
            if (!v) return true;
            const selected = new Date(v);
            const min = new Date(Date.now());
            min.setHours(0, 0, 0, 0);
            selected.setHours(0, 0, 0, 0);
            return selected <= min || 'Paid Date cannot be in the future';
          }
        ]
      },
      form: {
        amountPaid: 0,
        whenPaid: null,
        yearsSelected: []
      },
      isLoading: false,
      formValid: false
    };
  },
  methods: {
    ...mapActions('main', ['showSnackbar']),
    ...mapActions('user', ['logInUser']),
    initYearsSelected() {
      if (this.modalRequestCheckYears && Array.isArray(this.modalRequestCheckYears)) {
        this.form.yearsSelected = this.modalRequestCheckYears.map((item) => {
          return {
            label: item?.label,
            isChecked: false
          };
        });
      }
    },
    async handleSaveRequest() {
      const hasCheckedTaxYear = this.form.yearsSelected?.some((item) => item.isChecked === true);
      if (this.formValid === true && hasCheckedTaxYear) {
        this.isLoading = true;
        try {
          await applicationService.saveRequestCheck(this.form);
          this.showSnackbar({ text: successRequestCheckText, color: 'green' });
          this.handleClose();
        } catch (err) {
          console.error(err);
          this.showSnackbar({ text: errorRequestCheckText, color: 'red' });
        } finally {
          this.isLoading = false;
        }
      } else if (this.formValid === true && !hasCheckedTaxYear) {
        this.showSnackbar({ text: 'Please select at least one paid year', color: 'red' });
      }
    },
    resetForm() {
      this.form = {
        amountPaid: 0,
        whenPaid: null,
        yearsSelected: []
      };
    },
    handleClose() {
      this.$emit('update:modelValue', false);
    }
  }
};
</script>
